import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'

export type LegendProps = ModelProps<Legend>

/**
 * A legend. Its content lives in its versions.
 */
export class Legend extends Model<Legend> {
  id = Id.none

  @observable accessor workspaceId = Id.none
  @observable accessor inactive = false
}
